<template>
  <div id='RegisterByDay'></div>
</template>

<script>
// import G2 from '@antv/g2';
import chartMixin from '../../chartMixin';

export default {
  name: 'RegisterByDay',
  mixins: [chartMixin],
  data() {
    return {
      demoData: [{ days: 1, count: 10 }],
    };
  },
  props:[
    'year',
    'month'
  ],
  methods: {
    initData() {
      this.chart = new G2.Chart({
        container: 'RegisterByDay',
        forceFit: true,
        height: this.height,
        padding: [40, 20, 30, 50],
      });
      this.chart
        .source(this.data, {
          days: {
            min: 1,
            max: new Date(this.year,parseInt(this.month),0).getDate(),
            type: 'linear',
            tickCount: new Date(this.year,parseInt(this.month),0).getDate()+1,
          },
          count: {
            alias: '人数',
            formatter: val => {
              if (/\./.test(val)) {
                return '';
              }
              return val;
            },
          },
        })
        .tooltip({
          showTitle: false,
        })
        .line()
        .position('days*count');
      this.chart.line().position('days*count');
      this.chart.render();
    },
  },
};
</script>

